import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './QuotationBlock';

const QuotationSuspense = dynamic(() => import('./QuotationBlock'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicQuotation(props: Props) {
	return <QuotationSuspense {...props} />;
}
DynamicQuotation.displayName = 'DynamicQuotation';
